export default __webpack_public_path__ + "assets/audios/0cfa1e083ffcfba96d9118f1799307b6.mp3";